import { render } from "./CommunityOverview.vue?vue&type=template&id=df67e47c&scoped=true"
import script from "./CommunityOverview.vue?vue&type=script&lang=js"
export * from "./CommunityOverview.vue?vue&type=script&lang=js"

import "./CommunityOverview.vue?vue&type=style&index=0&id=df67e47c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df67e47c"]])

export default __exports__